/* query */
export const LAZY_LIMIT = 999

/* connection */
export const BRIDGE = "https://walletconnect.terra.dev"

/* api */
export const ASSETS = "https://assets.terra.dev"

/* website */
export const STATION = "https://station.money"
export const FINDER = "https://terrascope.info"
export const EXTENSION =
  "https://chrome.google.com/webstore/detail/aiifbnbfobpmeekipheeijimdpnlpgpp"
export const TUTORIAL =
  "https://docs-terra.pages.dev/learn/terra-station/Download/terra-station-desktop.html"

/* website: stake */
export const TERRA_VALIDATORS =
  "https://github.com/terra-money/validator-profiles/tree/master/validators/"

export const STAKE_ID = "https://stake.id/#/validator/"

/* ledger */
export const LEDGER_TRANSPORT_TIMEOUT = 120000

/* tx */
export const DEFAULT_GAS_ADJUSTMENT = 2
export const CLASSIC_DEFAULT_GAS_ADJUSTMENT = 2

/* swap */
export const TERRASWAP_COMMISSION_RATE = 0.003

/* placeholder */
// https://github.com/terra-money/localterra
export const SAMPLE_ADDRESS = "terra1x46rqay4d3cssq8gxxvqz8xt6nwlz4td20k38v"
